import { Edit as EditIcon } from '@mui/icons-material';

const Edit = (): JSX.Element => <EditIcon fontSize="inherit" />;

export default Edit;
